import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const EraserIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.80502 1.67663C8.48844 0.993208 9.59647 0.993208 10.2799 1.67663L13.1098 4.50651C13.7922 5.18893 13.7933 6.295 13.1123 6.97883L10.2896 9.81328L7.99771 12.0125C7.67183 12.3252 7.23768 12.4998 6.78604 12.4998L4.62305 12.4998C4.217 12.4998 3.82358 12.3586 3.5102 12.1004L1.63716 10.5571C0.839998 9.90023 0.782195 8.69945 1.51258 7.96906L7.80502 1.67663ZM9.21923 2.73729C9.1216 2.63965 8.96331 2.63965 8.86568 2.73729L6.30148 5.30148L9.49022 8.49022L12.0495 5.92036C12.1468 5.82267 12.1466 5.66466 12.0491 5.56717L9.21923 2.73729Z"
		></path>
		<path
			fill="currentColor"
			d="M1.5 13.5C1.22386 13.5 1 13.7239 1 14V14.5C1 14.7761 1.22386 15 1.5 15H14.5C14.7761 15 15 14.7761 15 14.5V14C15 13.7239 14.7761 13.5 14.5 13.5H1.5Z"
		></path>
	</svg>
))
